function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i)
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import { jsx } from "panel";
import { SvgIconEl } from "common/components/svg-icon";
import { ButtonEl } from "common/components/button";
import { ButtonTheme } from "common/components/button/constants";
import { SelectEl } from "common/components/select";
export function template() {
  return /* @__PURE__ */ jsx("div", { sel: ".mp-popover-card-container", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".mp-card-header.mp-popover-card-header" }, /* @__PURE__ */ jsx(SvgIconEl, { sel: ".svg-title-icon", attrs: {
    icon: this.attr("is-segmented") ? "segment" : "event"
  }, "data-sentry-element": "SvgIconEl", "data-sentry-source-file": "template.tsx" }), /* @__PURE__ */ jsx("div", { sel: ".mp-card-header-title" }, this.attr("title"), /* @__PURE__ */ jsx("div", { sel: ".mp-card-header-subtitle" }, this.attr("subtitle"))), /* @__PURE__ */ jsx(ButtonEl, { sel: ".mp-card-header-close", attrs: {
    theme: ButtonTheme.Tertiary,
    icon: "x"
  }, on: {
    click: this.helpers.handleClose
  }, "data-sentry-element": "ButtonEl", "data-sentry-source-file": "template.tsx" })), /* @__PURE__ */ jsx("div", { sel: ".body" }, /* @__PURE__ */ jsx("slot", { "data-sentry-element": "slot", "data-sentry-source-file": "template.tsx" })), /* @__PURE__ */ jsx("div", { sel: ".footer" }, /* @__PURE__ */ jsx("slot", { attrs: {
    name: "footer"
  }, "data-sentry-element": "slot", "data-sentry-source-file": "template.tsx" }), this.helpers.getMainOptions().map((buttonOption) => /* @__PURE__ */ jsx("div", { sel: ".button-option-container" }, !buttonOption.values ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(ButtonEl, { attrs: _objectSpread({
    theme: ButtonTheme.Secondary,
    icon: buttonOption.icon,
    disabled: buttonOption.isDisabled
  }, buttonOption.tooltip ? {
    tooltip: {
      "max-width": "250px",
      text: buttonOption.tooltip
    }
  } : {}), on: {
    click: this.helpers.handleSelect(buttonOption),
    mouseover: this.helpers.handleFocusItem(buttonOption),
    mouseout: this.helpers.handleUnfocusItem,
    disabled: buttonOption.disabled
  } }, /* @__PURE__ */ jsx("span", { sel: ".button-label" }, buttonOption.label))) : buttonOption.values ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(SelectEl, { attrs: _objectSpread({
    sections: [{
      items: buttonOption.values
    }],
    "selected-option": buttonOption.label,
    disabled: buttonOption.isDisabled
  }, buttonOption.tooltip ? {
    tooltip: {
      "max-width": "250px",
      text: buttonOption.tooltip
    }
  } : {}), on: {
    change: this.helpers.handleChange,
    focusItem: this.helpers.handleFocusItem(buttonOption),
    menuChange: this.helpers.handleUnfocusItem
  } })) : null)), this.helpers.hasOverflow() ? /* @__PURE__ */ jsx("div", { sel: ".button-option-container" }, /* @__PURE__ */ jsx(SelectEl, { attrs: {
    sections: [{
      items: this.helpers.getOverflowOptions()
    }],
    icon: {
      leftIcon: "hor-ellipsis"
    }
  }, on: {
    change: this.helpers.handleChange
  } })) : null));
}
